// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3lrxr","title":"AfterBackImages_title__1n5bb","images":"AfterBackImages_images__2S9Ox"};